import { Component } from 'react';
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';
import { QueryRenderer } from 'react-relay/legacy';
import { CatalogError } from './CatalogError';
import { catalogRootQuery } from '../catalogRootQuery';
import { getRelayEnvironment } from '../../utils/relayModernEnvironment';
import { Provider } from 'react-redux';
import { Spinner } from 'dibs-elements/exports/Spinner';
import commonStyles from '../styles/catalogCommon.scss';
import { IntlProvider } from 'dibs-react-intl';

// Helpers
import serverVars from 'server-vars';
import * as tracking from 'dibs-tracking';
import { getBuyerId } from 'dibs-cookie-jar';

// Components
import { CatalogLayout } from './CatalogLayout';

export class CatalogRenderer extends Component {
    constructor(props) {
        super(props);
        this.handlePageLoad = this.handlePageLoad.bind(this);
    }

    componentDidMount() {
        this.handlePageLoad();
    }

    handlePageLoad() {
        const initialDataLayerInfo = serverVars.get('tracking.initialDataLayerInfo');

        tracking.trackPageview({
            additional: {
                pageSubType: initialDataLayerInfo && initialDataLayerInfo.pageSubType,
                pageType: initialDataLayerInfo && initialDataLayerInfo.pageType,
            },
        });
    }

    render() {
        const userId = getBuyerId(document.cookie) || '';

        const variables = {
            ...this.props,
            hasUserId: !!userId,
            userId,
        };

        const environment = getRelayEnvironment(serverVars.get('catalog.records'));

        return (
            <QueryRenderer
                environment={environment}
                query={catalogRootQuery}
                variables={variables}
                render={({ error, props: relayProps }) => {
                    if (error) {
                        return <CatalogError />;
                    } else if (relayProps) {
                        const prevProps = {
                            relayEnvironment: environment,
                            ...variables,
                            ...relayProps,
                            ...this.state,
                        };
                        return <CatalogLayout {...prevProps} />;
                    } else {
                        return <Spinner containerClass={commonStyles.pageSpinner} />;
                    }
                }}
            />
        );
    }
}

CatalogRenderer.propTypes = {
    deviceType: PropTypes.string,
    pageTypeId: PropTypes.string,
    rootId: PropTypes.string,
};

export const createCatalogRenderer = options => {
    const { containerId, store, ...otherProps } = options;
    const root = createRoot(document.getElementById(containerId));

    root.render(
        <IntlProvider locale={serverVars.get('locale')} messages={serverVars.get('messages')}>
            <Provider store={store}>
                <CatalogRenderer {...otherProps} />
            </Provider>
        </IntlProvider>
    );
};
